import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { CrmReveal } from "./CrmMotion";

export const CrmFinalCtaSection = () => {
    const navigate = useNavigate();

    return (
        <section className="crm-cta">
            <div className="crm-container">
                <CrmReveal>
                    <div className="crm-cta__banner">
                        <h2>Ready to Grow with HonestiIQ?</h2>
                        <p>
                            Empower your sales and support teams with the complete customer growth platform
                            designed for modern businesses.
                        </p>
                        <div className="crm-cta__actions">
                            <Button className="crm-btn crm-btn--light" onClick={() => navigate("/contact")}>
                                Schedule Demo <ArrowRightOutlined />
                            </Button>
                            <Button className="crm-btn crm-btn--outline-light" onClick={() => navigate("/contact")}>
                                Get Started
                            </Button>
                        </div>
                    </div>
                </CrmReveal>
            </div>
        </section>
    );
};
